// extracted by mini-css-extract-plugin
export default {"eyebrow":"vvhL6r","title":"fzz9XF","spacer":"uSDCHV"};